function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var notificationListItemEntities = function notificationListItemEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byUserId: {},
    byUserIdAndViewedAtIsNull: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.LOGIN_SUCCESS:
    case ActionTypes.GET_AUTHENTICATION_SUCCESS:
      var byUserId = action.response.notificationListItemsByUserId;
      var byUserIdAndViewedAtIsNull = action.response.notificationListItemsByUserIdAndViewedAtIsNull;
      return merge({}, state, {
        byUserId: byUserId,
        byUserIdAndViewedAtIsNull: byUserIdAndViewedAtIsNull
      });
    case ActionTypes.GET_NOTIFICATIONTABBYUSERID_SUCCESS:
      var byUserId = _objectSpread({}, state.byUserId);
      byUserId[action.userId] = action.response.notificationListItemsByUserId[action.userId];
      return Object.assign({}, state, {
        byUserId: byUserId
      });
    case ActionTypes.GET_NOTIFICATIONTOASTSBYUSERID_SUCCESS:
      var byUserId = _objectSpread({}, state.byUserId);
      if (byUserId[action.userId] && action.sinceId !== undefined) byUserId[action.userId] = action.response.reverse().concat(byUserId[action.userId]);else if (byUserId[action.userId] && action.maxId !== undefined) byUserId[action.userId] = byUserId[action.userId].concat(action.response);else byUserId[action.userId] = action.response;
      return Object.assign({}, state, {
        byUserId: byUserId
      });
    case ActionTypes.GET_NOTIFICATIONTOASTSBYUSERIDANDVIEWEDATISNULL_SUCCESS:
      if (!action.response) return state;
      var byUserIdAndViewedAtIsNull = _objectSpread({}, state.byUserIdAndViewedAtIsNull);
      byUserIdAndViewedAtIsNull[action.userId] = action.response;
      return Object.assign({}, state, {
        byUserIdAndViewedAtIsNull: byUserIdAndViewedAtIsNull
      });
    case ActionTypes.POST_NOTIFICATION_SUCCESS:
      var embedded = action.response._embedded;
      var byUserIdAndViewedAtIsNull = _objectSpread({}, state.byUserIdAndViewedAtIsNull);
      var key = action.notification.user.id;
      byUserIdAndViewedAtIsNull[key] = byUserIdAndViewedAtIsNull[key].filter(function (toast) {
        return toast.notificationId !== action.notification.id || !embedded.viewedAt;
      });
      return Object.assign({}, state, {
        byUserIdAndViewedAtIsNull: byUserIdAndViewedAtIsNull
      });
    case ActionTypes.DELETE_GOALMEMBER_SUCCESS:
      if (!action.response.success) return state;
      var byUserIdAndViewedAtIsNull = _objectSpread({}, state.byUserIdAndViewedAtIsNull);
      var userId = action.goalMember.user.id;
      var memberId = action.goalMember.id;
      byUserIdAndViewedAtIsNull[userId] = byUserIdAndViewedAtIsNull[userId].filter(function (toast) {
        return !toast.memberById || !toast.memberById[memberId];
      });
      return Object.assign({}, state, {
        byUserIdAndViewedAtIsNull: byUserIdAndViewedAtIsNull
      });
    case ActionTypes.DELETE_USERFOLLOWER_SUCCESS:
      var byUserIdAndViewedAtIsNull = _objectSpread({}, state.byUserIdAndViewedAtIsNull);
      var userId = action.userFollower.followee.email;
      if (!byUserIdAndViewedAtIsNull[userId]) return state;
      var userFollowerId = action.userFollower.id;
      byUserIdAndViewedAtIsNull[userId] = byUserIdAndViewedAtIsNull[userId].filter(function (toast) {
        return !toast.userFollowerById || !toast.userFollowerById[userFollowerId];
      });
      return Object.assign({}, state, {
        byUserIdAndViewedAtIsNull: byUserIdAndViewedAtIsNull
      });
    case ActionTypes.DELETE_OPERATION_SUCCESS:
      var byUserIdAndViewedAtIsNull = _objectSpread({}, state.byUserIdAndViewedAtIsNull);
      var userId = action.operation.userId;
      if (!byUserIdAndViewedAtIsNull[userId]) return state;
      var operationId = action.operation.id;
      byUserIdAndViewedAtIsNull[userId] = byUserIdAndViewedAtIsNull[userId].filter(function (toast) {
        return !toast.operationById || !toast.operationById[operationId];
      });
      return Object.assign({}, state, {
        byUserIdAndViewedAtIsNull: byUserIdAndViewedAtIsNull
      });
    default:
      return state;
  }
};
export default notificationListItemEntities;